import { useState, useEffect } from "react";
import {
  Frame,
  Loading,
  Header,
  Print,
  VerContrato,
  ValidaUid,
} from "../components";
import { useNavigate } from "react-router-dom";
import { db } from "../config/firebase";
import { doc, getDoc } from "firebase/firestore";

const Contrato = () => {
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const buscaDados = async () => {
      const uid = await ValidaUid();

      if (uid) {
        const qry = await getDoc(doc(db, "ebserh2026", uid));

        const data = qry.data();

        if (data?.anoAtual === "2026" && data?.status === "a") {
          setDados(data);
          setLoading(false);
        } else {
          navigate("/home");
        }
      } else {
        navigate("/login");
      }
    };

    buscaDados();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      {!loading && (
        <Frame
          body={
            <div className="px-2">
              <VerContrato dados={dados} />
              <Print />
            </div>
          }
        />
      )}
    </>
  );
};

export default Contrato;
